{
  "status": {
    "BACKLOG": "Backlog",
    "TODO": "To do",
    "IN_PROGRESS": "In progress",
    "IN_REVIEW": "In review",
    "COMPLETED": "Completed",
    "CANCELLED": "Cancelled"
  },
  "priority": {
    "LOW": "Low",
    "NORMAL": "Normal",
    "HIGH": "High",
    "URGENT": "Urgent"
  },
  "teamRole": {
    "LEAD": "Lead",
    "MEMBER": "Member"
  },
  "personRole": {
    "CONTRIBUTOR": "contributor",
    "FOLLOWER": "follower"
  },
  "visibility": {
    "PERSONAL": "Personal",
    "PERSONALBody": "Only the people on this task.",
    "TEAM": "Team",
    "TEAMBody": "The task's people and the whole responsible team.",
    "RESTRICTED": "Restricted",
    "RESTRICTEDBody": "The task's people and the team's leads only.",
    "PROJECT": "Project",
    "PROJECTBody": "The task's people, the project's team and, with a team, its members.",
    "viewAllNote": "People with the See every task permission can always see it."
  },
  "due": {
    "none": "No due date",
    "today": "Today",
    "late_one": "{{n}} day late",
    "late_other": "{{n}} days late",
    "lateToday": "late",
    "committedWas": "Committed for {{date}}",
    "committedSr": "Committed date, since moved:"
  },
  "blocked": {
    "label": "Blocked"
  },
  "people": {
    "inactive": "inactive",
    "contributors": "Contributors",
    "followers": "Followers",
    "addContributor": "Add contributor",
    "addFollower": "Add follower",
    "remove": "Remove {{name}}",
    "none": "Nobody yet",
    "unassigned": "Unassigned",
    "teamLeadsReview": "The team's leads"
  },
  "progress": {
    "subtasks": "{{done}} of {{total}} subtasks resolved",
    "checklist": "{{done}} of {{total}} checklist steps done"
  },
  "pickers": {
    "person": "Choose a person",
    "searchPeople": "Search people",
    "noPeople": "No one matches",
    "peopleError": "People could not be loaded."
  },
  "fields": {
    "number": "Number",
    "title": "Title",
    "team": "Responsible team",
    "assignee": "Assignee",
    "reviewer": "Reviewer",
    "requester": "Requester",
    "dueDate": "Due date",
    "dueTime": "Due time",
    "customer": "Customer",
    "priority": "Priority",
    "type": "Type",
    "status": "Status",
    "description": "Description",
    "expectedResult": "Expected result",
    "completionNote": "Completion note",
    "plannedStart": "Planned start",
    "estimate": "Estimate (hours)",
    "actual": "Actual effort (hours)",
    "tags": "Tags",
    "visibility": "Who can see it",
    "review": "Review",
    "committedDueDate": "Committed due date"
  },
  "form": {
    "title": "New task",
    "subtaskTitle": "New subtask of {{number}}",
    "linkedTo": "Linked to {{label}}",
    "titlePlaceholder": "What has to be done, in a few words",
    "expectedResultPlaceholder": "e.g. Items imported, rejected rows fixed, totals match the approved file",
    "noTeam": "No team (personal task)",
    "unassigned": "Unassigned (team queue)",
    "assignToMe": "Me",
    "noCustomer": "No customer",
    "teamLeadsReview": "The team's leads",
    "moreOptions": "More options",
    "fewerOptions": "Fewer options",
    "reviewRequired": "Needs review before it is complete",
    "backlog": "Not committed yet: keep it in the backlog",
    "required": "Required before the main task can be completed",
    "create": "Create task",
    "createSubtask": "Create subtask",
    "hints": {
      "noTeam": "Without a team the task is personal.",
      "queue": "Waits in the team's queue until someone takes it.",
      "me": "Personal tasks are yours unless you choose someone.",
      "dueTime": "Optional. Without it the task is due by the end of the day.",
      "expectedResult": "What done looks like. The reviewer checks the work against it.",
      "review": "Someone other than the assignee accepts the work or returns it with feedback.",
      "reviewer": "Without one, any lead of the team can review.",
      "estimate": "In hours, e.g. 2.5.",
      "tags": "Separate tags with commas."
    },
    "errors": {
      "title": "Give the task a title.",
      "dueDate": "A committed task needs a due date. Add one, or keep the task in the backlog.",
      "expectedResult": "Say what the reviewer will check.",
      "dueTimeWithoutDate": "Set the due date before a time.",
      "reviewerIsAssignee": "The reviewer must be someone other than the assignee.",
      "estimate": "Enter hours as a number, e.g. 2.5."
    }
  },
  "errors": {
    "TASK_MOVE_NOT_ALLOWED": "The task cannot move there from where it is.",
    "TASK_NOT_READY": "This task is missing what committed work needs: a due date, an owner, and an expected result when it is reviewed.",
    "TASK_SUBTASKS_OPEN": "Finish or cancel the required subtasks first.",
    "TASK_ALREADY_CLAIMED": "Someone took this task a moment ago.",
    "TASK_CLAIM_NOT_ALLOWED": "Only members of the responsible team can take this task.",
    "TASK_REVIEWER_IS_ASSIGNEE": "Someone other than the assignee must review the work.",
    "TASK_NOT_PERMITTED": "You cannot do this with this task.",
    "TASK_REASON_REQUIRED": "Give a reason; it stays in the task's history.",
    "TASK_INVALID_PARENT": "A subtask takes its parent's customer, and cannot have subtasks of its own.",
    "TASK_INVALID_VISIBILITY": "That visibility does not fit this task: check its team and main task.",
    "TASK_INVALID_PERSON": "Choose active people of the company.",
    "TASK_INVALID_LINK": "That record does not exist or you cannot see it.",
    "TASK_CLOSED": "Reopen the task before changing it.",
    "TASK_NOT_BLOCKED": "This task is not blocked.",
    "TASK_ALREADY_BLOCKED": "This task is already blocked.",
    "TEAM_ARCHIVED": "That team is archived. Choose another team.",
    "EXPORT_TOO_LARGE": "Too many tasks match. Narrow the filters and export again."
  },
  "toast": {
    "created": "{{number}} created",
    "moved": "{{number}} is now {{status}}",
    "assigned": "{{number}} assigned",
    "claimed": "You took {{number}}",
    "blocked": "{{number}} marked blocked",
    "unblocked": "{{number}} unblocked",
    "rescheduled": "Due date changed",
    "requested": "Date request sent",
    "saved": "Changes saved",
    "commented": "Comment added",
    "followed": "You follow {{number}}",
    "unfollowed": "You no longer follow {{number}}",
    "exported": "Tasks exported",
    "personAdded": "{{name}} added",
    "personRemoved": "{{name}} removed",
    "linkRemoved": "Link removed"
  },
  "actions": {
    "new": "New task",
    "export": "Export",
    "rowActions": "Actions for {{number}}",
    "open": "Open",
    "openFullPage": "Open full page",
    "moveTo": "Move to…",
    "take": "Take task",
    "assign": "Assign",
    "edit": "Edit details",
    "reschedule": "Change due date",
    "requestDate": "Ask for a new date",
    "block": "Mark blocked",
    "unblock": "Unblock",
    "follow": "Follow",
    "unfollow": "Stop following",
    "history": "Audit history",
    "addSubtask": "Add subtask",
    "close": "Close",
    "more": "More actions"
  },
  "move": {
    "commit": "Commit to To do",
    "backlog": "Move to backlog",
    "start": "Start work",
    "pause": "Pause (back to To do)",
    "submit": "Submit for review",
    "complete": "Mark complete",
    "accept": "Accept",
    "return": "Return with feedback",
    "cancel": "Cancel task",
    "reopen": "Reopen"
  },
  "moveDialog": {
    "cancelTitle": "Cancel {{number}}?",
    "cancelBody": "Cancelled work is not counted as delivered. Say why; it stays in the history.",
    "reopenTitle": "Reopen {{number}}?",
    "reopenBody": "The earlier result stays in the history. Say what is left to do.",
    "returnTitle": "Return {{number}} to the assignee",
    "returnBody": "Say what to change. The assignee is told, and the task goes back in progress.",
    "submitTitle": "Submit {{number}} for review",
    "submitBody": "The reviewer checks the work against the expected result.",
    "completeTitle": "Complete {{number}}",
    "completeBody": "Note what was delivered. Attach evidence on the task before completing it.",
    "reason": "Reason",
    "feedback": "What to change",
    "note": "What was delivered",
    "noteHint": "Optional. Shown on the task as the completion note.",
    "actual": "Effort spent (hours)",
    "actualHint": "Optional. Compared with the estimate in reports.",
    "keep": "Keep task",
    "confirm": {
      "cancel": "Cancel task",
      "reopen": "Reopen task",
      "return": "Return to assignee",
      "submit": "Submit for review",
      "complete": "Mark complete"
    }
  },
  "assignDialog": {
    "title": "Assign {{number}}",
    "body": "The team owns the responsibility; one person does the work.",
    "queue": "Leave in the team queue",
    "notInTeam": "Not a member of the team.",
    "note": "Note for the assignee",
    "save": "Save assignment"
  },
  "blockDialog": {
    "title": "Mark {{number}} blocked",
    "body": "The deadline stays as it is. Say what is in the way and who follows it up.",
    "reason": "What is blocking the work",
    "waitingOn": "Waiting on",
    "waitingOnHint": "A person, a company or a document, e.g. ABC Trading's approved item list.",
    "followUpOwner": "Who follows up",
    "followUpDate": "Follow up on",
    "save": "Mark blocked"
  },
  "unblockDialog": {
    "title": "Unblock {{number}}",
    "note": "What changed",
    "save": "Unblock"
  },
  "rescheduleDialog": {
    "title": "Change the due date of {{number}}",
    "body": "The committed date stays on record: reports measure delivery against it.",
    "reason": "Why the date changes",
    "save": "Change due date"
  },
  "requestDateDialog": {
    "title": "Ask for a new due date",
    "body": "The requester and the team's leads decide. The current date stays until they change it.",
    "proposed": "Proposed date",
    "reason": "Why",
    "save": "Send request"
  },
  "editSheet": {
    "title": "Edit {{number}}",
    "save": "Save changes"
  },
  "checklist": {
    "label": "Checklist",
    "add": "Add step",
    "placeholder": "A small step of this task",
    "remove": "Remove step: {{text}}",
    "empty": "No steps yet.",
    "removed": "Step removed: {{text}}",
    "undo": "Undo"
  },
  "links": {
    "title": "Related records",
    "restricted": "Restricted record",
    "moduleOff": "Turned off for your company; the link stays until it is turned back on",
    "voided": "Voided",
    "missing": "No longer exists",
    "remove": "Remove link to {{label}}",
    "empty": "None. Create tasks from a document's page to link it."
  },
  "dates": {
    "created": "Created",
    "assigned": "Assigned",
    "started": "Started",
    "submitted": "Submitted",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "by": "{{when}} by {{name}}"
  },
  "detail": {
    "notFound": "This task does not exist or you cannot see it.",
    "youAre": {
      "ASSIGNEE": "You do this task",
      "REVIEWER": "You review this task",
      "REQUESTER": "You asked for this task",
      "CONTRIBUTOR": "You help with this task",
      "FOLLOWER": "You follow this task",
      "TEAM_LEAD": "You lead its team",
      "TEAM_MEMBER": "Your team owns this task",
      "OTHER": "You can see this task"
    },
    "sections": {
      "description": "Description",
      "expectedResult": "Expected result",
      "completionNote": "Completion note",
      "subtasks": "Subtasks",
      "attachments": "Evidence and files",
      "activity": "Activity",
      "people": "People",
      "context": "Context",
      "dates": "Dates",
      "effort": "Effort"
    },
    "noDescription": "No description.",
    "noExpectedResult": "No expected result yet. Say what done looks like.",
    "parent": "Part of {{number}}",
    "hiddenSubtasks": "Some subtasks are hidden from you by their visibility.",
    "noSubtasks": "No subtasks. Split work that someone else owns into subtasks.",
    "cancelReason": "Cancelled: {{reason}}",
    "reopened": "Times reopened: {{n}}",
    "returned": "Times returned by the reviewer: {{n}}",
    "queueWaiting": "Waiting in {{team}}'s queue since {{date}}",
    "blocker": {
      "title": "Blocked since {{date}}",
      "waitingOn": "Waiting on {{who}}",
      "followUp": "{{name}} follows up on {{date}}",
      "followUpNoDate": "{{name}} follows up"
    },
    "review": {
      "title": "Waiting for your review",
      "body": "Check the work against the expected result, then accept it or return it with what to change."
    },
    "reviewWaiting": "Submitted for review",
    "reviewNone": "Not reviewed",
    "reviewBy": "Reviewed by {{name}}",
    "estimateHours": "{{h}} h",
    "estimate": "Estimate",
    "actual": "Actual effort",
    "typeLine": "Type: {{type}}",
    "addDescription": "Add description",
    "addExpectedResult": "Add expected result"
  },
  "activity": {
    "title": "Activity",
    "filter": {
      "all": "All",
      "comments": "Comments",
      "history": "History"
    },
    "composer": "Write a comment",
    "composerHint": "The task's people are told. Ctrl+Enter sends.",
    "send": "Comment",
    "empty": "Nothing yet.",
    "loadMore": "Show older",
    "system": "The system",
    "events": {
      "CREATED": "created the task",
      "UPDATED": "edited {{fields}}",
      "ASSIGNED": "assigned it to {{to}}",
      "ASSIGNED_queue": "put it back in the team queue",
      "CLAIMED": "took the task",
      "TEAM_CHANGED": "changed the team",
      "MOVED": "moved it from {{from}} to {{to}}",
      "REVIEW_ACCEPTED": "accepted the work",
      "REVIEW_RETURNED": "returned the work",
      "BLOCKED": "marked it blocked: {{reason}}",
      "UNBLOCKED": "unblocked it",
      "DUE_CHANGED": "moved the due date from {{from}} to {{to}}",
      "DUE_SET": "set the due date to {{to}}",
      "DATE_REQUESTED": "asked to move the due date to {{proposed}}: {{reason}}",
      "PRIORITY_CHANGED": "changed the priority from {{from}} to {{to}}",
      "PERSON_ADDED": "added {{name}} as {{role}}",
      "PERSON_REMOVED": "removed {{name}}",
      "LINK_ADDED": "linked a record ({{type}})",
      "LINK_REMOVED": "removed a linked record ({{type}})",
      "SUBTASK_ADDED": "added subtask {{number}}",
      "REOPENED": "reopened it: {{reason}}",
      "CANCELLED": "cancelled it: {{reason}}"
    },
    "reasonLabel": "Reason: {{reason}}",
    "fieldNames": {
      "title": "the title",
      "description": "the description",
      "expectedResult": "the expected result",
      "type": "the type",
      "reviewRequired": "the review requirement",
      "required": "whether it is required",
      "plannedStart": "the planned start",
      "estimateMinutes": "the estimate",
      "tags": "the tags",
      "requesterId": "the requester",
      "reviewerId": "the reviewer",
      "customerId": "the customer",
      "visibility": "who can see it"
    }
  },
  "myWork": {
    "title": "My work",
    "intro": "What needs you today, and the work you asked others for.",
    "strip": {
      "overdue": "Overdue",
      "dueToday": "Due today",
      "blocked": "Blocked",
      "toReview": "To review",
      "approvals": "Approvals",
      "queue": "Team queues",
      "approvalsOverdue_one": "{{n}} overdue",
      "approvalsOverdue_other": "{{n}} overdue"
    },
    "sections": {
      "attention": "Needs attention",
      "assigned": "Assigned to me",
      "review": "To review",
      "requested": "Requested by me",
      "following": "Following",
      "queue": "Team queues",
      "approvals": "Approvals waiting for you",
      "visitsToday": "Visits today",
      "serviceDecisions": "Service decisions"
    },
    "hints": {
      "attention": "Overdue, due today, and blockers you follow up.",
      "queue": "Unassigned work in your teams, oldest first.",
      "approvals": "Business approvals are decided in My approvals, with their own Approve, Reject and Return.",
      "visitsToday": "Your teams' visits, earliest first. Open one to work on it.",
      "serviceDecisions": "Follow-up requests to approve, payments to verify, and your requests returned to you."
    },
    "empty": {
      "attention": "Nothing overdue or due today.",
      "assigned": "No open tasks are assigned to you.",
      "review": "Nothing waits for your review.",
      "requested": "Nothing you asked for is open.",
      "following": "You do not follow any open task.",
      "queue": "Your teams' queues are empty.",
      "approvals": "No approvals wait for you.",
      "visitsToday": "No visits for your teams today.",
      "serviceDecisions": "No service decisions wait for you."
    },
    "openApprovals": "Open My approvals",
    "showInRegister": "See all in Tasks",
    "badge": "{{n}} need your attention",
    "queuedSince": "Unassigned since {{time}}",
    "openMyVisits": "Open My visits",
    "visitLabel": "{{label}}, {{customer}}",
    "service": {
      "followUpsToDecide_one": "{{n}} follow-up request to approve",
      "followUpsToDecide_other": "{{n}} follow-up requests to approve",
      "collectionsToVerify_one": "{{n}} payment to verify ({{amount}})",
      "collectionsToVerify_other": "{{n}} payments to verify ({{amount}})",
      "returned": "Follow-up request on {{label}} returned · {{customer}}"
    },
    "moreInRegister_one": "{{n}} more in Tasks",
    "moreInRegister_other": "{{n}} more in Tasks"
  },
  "list": {
    "title": "Tasks",
    "views": "Task views",
    "view": {
      "open": "Open",
      "mine": "Mine",
      "unassigned": "Unassigned",
      "overdue": "Overdue",
      "blocked": "Blocked",
      "review": "To review",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "all": "All"
    },
    "layout": {
      "label": "Layout",
      "list": "List",
      "board": "Board",
      "calendar": "Calendar"
    },
    "searchPlaceholder": "Number, title, customer, person",
    "searchLabel": "Search tasks",
    "clearSearch": "Clear search",
    "tableLabel": "Tasks",
    "clearFilters": "Clear filters",
    "filters": {
      "team": "Team",
      "allTeams": "All teams",
      "assignee": "Assignee",
      "anyone": "Anyone",
      "me": "Me",
      "nobody": "Unassigned",
      "priority": "Priority",
      "anyPriority": "Any priority",
      "due": "Due",
      "anyDue": "Any due date",
      "dueOptions": {
        "overdue": "Overdue",
        "today": "Due today",
        "week": "Next 7 days",
        "later": "Later",
        "none": "No due date"
      },
      "active": "Filtered by: {{filters}}",
      "customer": "Customer",
      "drill": {
        "stale": "no update for 7 days",
        "inactiveAssignee": "inactive assignee",
        "late": "completed late",
        "reworked": "returned or reopened",
        "following": "following",
        "blocked": "blocked",
        "myBlocked": "blocked: assigned to me or blockers I follow up",
        "completedRange": "completed {{from}} – {{to}}",
        "dueRange": "due {{from}} – {{to}}",
        "tag": "tag {{tag}}",
        "requester": "requested by me",
        "reviewer": "reviewer",
        "status": "status {{status}}",
        "type": "type {{type}}",
        "onTime": "completed on time",
        "committedRange": "committed for {{from}} – {{to}}",
        "deliverable": "without subtasks",
        "hasCustomer": "customer work",
        "noCustomer": "internal work"
      }
    },
    "empty": {
      "title": "No tasks yet",
      "body": "Create a task, or start one from a customer or a document.",
      "filteredTitle": "No tasks match",
      "filteredBody": "Try other filters or clear them.",
      "view": "No tasks in this view."
    }
  },
  "columns": {
    "number": "Number",
    "title": "Title",
    "customer": "Customer",
    "team": "Team",
    "assignee": "Assignee",
    "status": "Status",
    "priority": "Priority",
    "due": "Due",
    "progress": "Progress",
    "updated": "Last update"
  },
  "board": {
    "label": "Task board",
    "column": "{{status}} column",
    "empty": "No tasks",
    "more": "Showing the first {{shown}} of {{total}}",
    "completedRecent": "Completed in the last 14 days",
    "moving": "Moving {{number}}…",
    "dragHint": "Drag a card to another column, or use its Move to… menu.",
    "refused": "{{number}} stayed in {{status}}: {{reason}}"
  },
  "related": {
    "title": "Tasks",
    "new": "New task",
    "empty": "No tasks yet.",
    "emptyBody": "Create a task to follow up on this record.",
    "counts": {
      "open": "Open",
      "overdue": "Overdue",
      "blocked": "Blocked",
      "completed": "Completed"
    },
    "showAll": "See all in Tasks",
    "unavailable": "Tasks could not be loaded."
  },
  "calendar": {
    "title": "Calendar",
    "intro": "Due dates and scheduled work.",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "previousWeek": "Previous week",
    "nextWeek": "Next week",
    "today": "Today",
    "mode": {
      "label": "Calendar view",
      "month": "Month",
      "week": "Week"
    },
    "scope": {
      "label": "Show",
      "all": "Open and completed",
      "open": "Open only"
    },
    "starts": "Show planned starts",
    "startsPrefix": "Starts",
    "more": "+{{n}} more",
    "newOnDay": "New task on {{date}}",
    "gridLabel": "Tasks by day",
    "dayLabel": "{{date}}",
    "chipLabel": "{{number}} {{title}}, {{status}}",
    "chipStartsLabel": "{{number}} {{title}} starts",
    "weekRange": "{{from}} – {{to}}",
    "unscheduled": {
      "title": "Unscheduled",
      "hint": "Open work with no due date. Drag one onto a day to schedule it.",
      "empty": "Everything open has a due date.",
      "showAll": "See all in Tasks",
      "hintTouch": "Open work with no due date. Open one and set its due date.",
      "failed": "The unscheduled work could not be loaded."
    },
    "truncated": "Only the first 1,000 tasks of this period are shown. Narrow the filters to see the rest.",
    "agendaEmpty": "No tasks in this period.",
    "keyboardHint": "Without a mouse: open a task and use Change due date.",
    "visits": "Show my visits",
    "visitChipLabel": "Visit {{label}}, {{customer}}, {{window}}",
    "visitsUnavailable": "Your visits could not be loaded.",
    "introTouch": "Due dates and scheduled work. To move a task to another day, open it and use Change due date.",
    "holiday": "Holiday:",
    "holidayProvisional": "{{name}} (provisional)",
    "dragHint": "Drag a task to another day to change its due date: you confirm the change, and it is recorded."
  }
}
